module.exports = __webpack_public_path__ + "static/media/zadania-matematyczne-klasa-6-m2.9e4723aa.jpg";